<div class="flex flex-col gap-2 p-4">
  @for (row of skeletonRows(); track $index) {
    <div class="flex gap-4 items-center">
      @for (col of skeletonCols(); track $index) {
        <div class="skeleton-cell flex-1">
          <div class="skeleton-bar"></div>
        </div>
      }
    </div>
  }
</div>
